// extracted by mini-css-extract-plugin
export var content = "_og-1";
export var fullScreen = "_og-0";